(function($) {

	//
	$(document).ready(function() {

		//
		var $body = $('body');

		//
		$body.on('click', '.faq-list dt', function() {

			// If item is open
			if($(this).hasClass('open')) {

				// Close item.
				$(this).addClass('closing').find('+ dd').slideToggle(400, function() {
					$(this).prev('dt').removeClass('open');
					$(this).prev('dt').removeClass('closing');
				});

			} else {

				// Else open item.
				$(this).addClass('opening').find('+ dd').slideToggle(400, function() {
					$(this).prev('dt').addClass('open');
					$(this).prev('dt').removeClass('opening');
				});
			}
		});
	})
})(window.jQuery);
